import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { useStakeDialog } from './logic/useStakeDialog'
import { StakeView } from './views/StakeView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { testIds } from '@/ui/utils/testIds'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface StakeContainerProps {
  closeDialog: () => void
  onSuccess?: (spkStaked: NormalizedNumber) => void
  prefillWithMax?: boolean
  successViewProceedText?: string
}

function StakeDialogContentContainer(props: StakeContainerProps) {
  const { spk, staked, selectableAssets, assetsFields, form, actionsViewState, pageStatus, txOverview } =
    useStakeDialog({ prefillWithMax: props.prefillWithMax, onSuccess: props.onSuccess })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        objectiveType="stakeSpk"
        tokenWithValue={{ token: spk, value: staked }}
        proceedText={props.successViewProceedText ?? 'Back to Staking'}
        onProceed={props.closeDialog}
        successViewProceedButtonDataTestId={testIds.spkStaking.stakeDialog.success.proceedButton}
      />
    )
  }

  return (
    <StakeView
      form={form}
      selectableAssets={selectableAssets}
      assetsFields={assetsFields}
      actionsViewState={actionsViewState}
      txOverview={txOverview}
    />
  )
}

const StakeDialogContentContainerWithSuspense = withSuspense(StakeDialogContentContainer, DialogContentSkeleton)
export { StakeDialogContentContainerWithSuspense as StakeDialogContentContainer }
